import axiosInstance from "../../../config/axios";
import { resolveLanguage } from "../../../i18n/languages";

// Persist the retailer's selected language on the server.
// `language` is the canonical lowercase name (e.g. "arabic"); the backend
// expects the same lowercase name in the body — matching the request header.
export const updateRetailerLanguage = async (language: string) => {
  const response = await axiosInstance.put("/retailer/updateLanguage", {
    language: resolveLanguage(language).name,
  });
  return response.data;
};
